import { STATSIG_OVERRIDES_KEY } from 'mt-shared';

import { OPERATIONS_FEATURE_FLAGS } from '@services/feature-flags/operations.constants';

/**
 * forge-foundry sandbox mode.
 *
 * `SANDBOX_MODE` is a build-time flag (webpack DefinePlugin, driven by
 * `local.sandboxMode`) set ONLY in the ephemeral sandbox image. It is
 * absent/false in local dev, preview and production, so every `IS_SANDBOX` guard
 * is inert outside the sandbox.
 *
 * Webpack proxies `/api` and `/log-in` to the k2web backend selected when the
 * sandbox image is built. This module only seeds Statsig local overrides (there
 * is no Statsig project in the sandbox).
 */
export const IS_SANDBOX: boolean = typeof SANDBOX_MODE !== 'undefined' && SANDBOX_MODE === true;

/** Gates forced on in the sandbox (no real Statsig project; everything else defaults). */
const SANDBOX_STATSIG_GATES: ReadonlyArray<string> = [
  OPERATIONS_FEATURE_FLAGS.AI_VISION_WASTE_ENABLED,
  OPERATIONS_FEATURE_FLAGS.AI_VISION_WASTE_SVC_VERIFICATION_ENABLED,
  OPERATIONS_FEATURE_FLAGS.AI_VISION_WASTE_EVENTS_ENABLED,
  OPERATIONS_FEATURE_FLAGS.AI_VISION_WASTE_OOC_ENABLED,
];

/**
 * Force the sandbox's gates on via mt-shared's built-in LocalOverrideAdapter (it
 * loads overrides from `STATSIG_OVERRIDES_KEY` at module init). Must run before the
 * Statsig service module loads — call it from validate-session, which executes
 * before boot. No-op outside the sandbox.
 */
export function seedSandboxStatsigOverrides(): void {
  if (!IS_SANDBOX) return;
  const gate: Record<string, boolean> = {};
  SANDBOX_STATSIG_GATES.forEach((g: string): void => { gate[g] = true; });
  sessionStorage.setItem(STATSIG_OVERRIDES_KEY, JSON.stringify({
    gate,
    dynamicConfig: {},
    ishighlighterEnabled: false,
    sandboxMode: true,
  }));
}
